import React from 'react'

export default function Dashboard() {
  return (
    <div class="alert alert-success" role="alert">
  <h4 class="alert-heading">Well done!</h4>
  <p>Aww yeah, you successfully Logged in. </p>
</div>
  )
}
